import HTTP from "./http.service";
import Plans from "./plans.service";
import Storage from "./storage.service";
// import User from "./user.service";
// // import Flow from "./flow.service";
// import Countries from "./countries.service";
// import Helpers from "../helpers/shared.helper";
// import Moment from "moment";

var Offers = {};

Offers.getAvailableOffers = (ProductCode = "") => {
	let config = {
		method: "get",
		// url: `/offers/list${Settings.version && Settings.version === "_kw_onboard" ? "" :  "?is_5g"}`
		// url: `/offers/list${ProductCode ? "?is_5g=true&product_code="+ProductCode:""}`
		url: `/offers/list${ProductCode ? "?product_code="+ProductCode:""}`
	};
	return HTTP(config);
};

Offers.get5gAvailableOffers = () => {
	let config = {
		method: "get",
		url: "/offers/list?is_5g=true"
	};
	return HTTP(config);
};

Offers.checkPromoCode = (code, number = null) => {
	let config = {
		method: "get",
		url: `/promo/check?number=${number}&code=${code}`,
	};
	return HTTP(config);
};

Offers.applyOffer = ( promotion_id,number=null) => {
	let config = {
		method: "post",
		url: "/offers/apply",
		data: {
			number,
			promotion_id
		}
	};
	return HTTP(config);
};

Offers.removeOffer = (promotion_id,number=null) => {
	let config = {
		method: "DELETE",
		url: "/offers",
		data: {
			number,
			promotion_id
		}
	};
	return HTTP(config);
};

Offers.getOffersList=(forceFetch=false)=>{
	return Storage.getOrfetch("Offers", Offers.getAvailableOffers, forceFetch)
	.then(response=>{
		if(response.data && response.data.Offers){
			Storage.set("Offers", response.data.Offers)
			Storage.set("ESIM_DOUBLE_DATA",response?.data?.Offers
			.filter(item=>item.OfferType==="ESIM_DOUBLE_DATA")[0].IsApplied);
		}
	})
	.catch(err=>{})

}

Offers.getOfferByType=(offerType,offersList=null,checkInStorage=true)=>{
	let offers=null;
	if(checkInStorage && !offersList){
		offers=Storage.get("Offers") ? Storage.get("Offers") : null;
		if(!offers) return null;
	}else{
		offers=offersList;
	}
	for(let item in offers){
		if(offers[item].OfferType===offerType)
		return offers[item];
	}

	return null;
    
}

Offers.applyOfferByPromotionID=(promotion_id, number=null, togglerApply=false)=>{
	return Offers.applyOffer(promotion_id, number)
	.then(response=>{
		
     return Offers.getOffersList(true)
	  .then(response=>{
		//   Plans.getPlans("Predefined",true);
		if(togglerApply) return;

		 return Plans.getPlans("Available",true,true)
		 .then(response=>{
             return Plans.getPlans("Predefined",true, true)
			 .then(response=>{
				Storage.set("eSimModal", { SHOW: false , APPLIED:true});
			 }).catch(err=>{
				Storage.set("eSimModal", { SHOW: false , CANCELED:true});
			 })
		 })
		 .catch(err=>{

		 });
	  }).catch(err=>{

	  });
	})
	.catch(err=>{})
}

export default Offers;